import React, { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import ContainerLoader from '../../components/loader/container-loader';
import AzureLogin from '../auth/AzureLogin';
import AuthenticateRoute from './AuthenticateRoute';
import RedirectIfAuthenticatedRoute from './RedirectIfAuthenticatedRoute';
import { MarketingHubRouteKeys, ProcessHubRouteKeys, ResourcePulseHubRouteKeys, RouteKeys, PeopleHubRouteKeys, ContractsHubRouteKeys, TalentTransformationalHubRouteKeys, PracticeHubRouteKeys, FlipHubRouteKeys, ImmigrationHubRouteKeys, AdminHubRouteKeys } from './route-keys';
import AddUser from '../../components/add-user/addUser';
import WallOfFame from '../../components/wallOfFrame/walloffame';
import WhatsNew from '../../components/whatsnew/whatsnew';
import WhatsNewForm from '../../components/whatsnew/whatsNewForm';
import AddPolicyForm from '../../components/AddPolicyForm/AddPolicyForm';
import ManagePolicy from '../../components/AddPolicyForm/ManagePolicy';
import ClientSummary from '../../components/clientSummary/ClientSummary';
import Contact from '../../components/contact/Contact';
import WalloffameForm from '../../components/wallOfFrame/walloffameForm';
import ManageAgilisiumInsights from '../../components/manageAgilisiumInsights/ManageAgilisiumInsights';
import InsightsForm from '../../components/manageAgilisiumInsights/insightsForm';
import PrivacyPolicy from '../../components/privacyPolicy/PrivacyPolicy';
import TermsAndConditions from '../../components/termsandConditions/TermsAndConditions';
import ItHub from '../../components/It_hub/ItHub';
import ItHubForm from '../../components/It_hub/ItHubForm';
import FlashNews from '../../components/FlashNews/FlashNews';
import FlashNewsForm from '../../components/FlashNews/FlashNewsForm';
import OrganizationChart from '../about/organizationChart/OrganizationChart';
import ManageLearningLounge from '../../components/learningLoungeAdmin/ManageLearningLounge';
import LearningLoungeTable from '../../components/learningLoungeAdmin/LearningLoungeTable';
import LearningLoungeForm from '../../components/learningLoungeAdmin/LearningLoungeForm';
import LearningLounge from '../../components/learningLounge/LearningLounge';
import ClientDetails from '../../components/ClientDetails/ClientDetails';
import ClientDetailsForm from '../../components/ClientDetails/ClientDetailsForm';
import ManageDepartments from '../../components/managedeparments/ManageDepartments';
import DepartmentsForm from '../../components/managedeparments/DepartmentsForm';
import SimpleLineChart from '../../components/reportsPage/SimpleLineChart';
import Survey from '../../components/survey/Survey';
import ManageSurvey from '../../components/survey/ManageSurvey';
import ManageSurveyForm from '../../components/survey/SurveyMasterForm';
import SurveyMasterForm from '../../components/survey/SurveyMasterForm';
import SurveyQuestionsForm from '../../components/survey/SurveyQuestionsForm';
import ProcessHub from '../../components/processHub/ProcessHub';
import ManageHubSpoc from '../../components/managehubspoc/ManageHubSpoc';
import HubSpocForm from '../../components/managehubspoc/HubSpocForm';


const Home = lazy(() => import('../home'));
const EmployeeComms = lazy(() => import('../employeeComms'));
const NotFound = lazy(() => import('../notfound'));
const AuthPage = lazy(() => import('../auth'));
const CreateUser = lazy(() => import('../../components/Crud/CreateUser'));
const EditUser = lazy(() => import('../../components/Crud/EditUser'));
const About = lazy(() => import('../about'))
const KnowYourAssociates = lazy(() => import('../../components/knowYourAssociates/KnowYourAssociates'))
const AssociateDetails = lazy(() => import('../../components/associateDetails'))
const Policies = lazy(() => import('../../components/policies/Policies'))
const ComingSoon = lazy(() => import('../../components/comingsoon/ComingSoon'))
const ManageDocuments = lazy(() => import('../../components/manageDocuments/ManageDocuments'))
const DocumentsForm = lazy(() => import('../../components/manageDocuments/DocumentsForm'))
const MarketingHub = lazy(() => import('../../components/marketingHub/MarketingHub'))
const Solutions = lazy(() => import('../../components/marketingHub/solutions/Solutions'))
const ManageSolutions = lazy(() => import('../../components/marketingHub/manageSolutions/ManageSolutions'))
const SolutionsForm = lazy(() => import('../../components/marketingHub/manageSolutions/SolutionsForm'))
const ManageMarketingBrochures = lazy(() => import('../../components/marketingHub/manageMarketingBrochures/ManageMarketingBrochures'))
const MarketingBrochuresForm = lazy(() => import('../../components/marketingHub/manageMarketingBrochures/MarketingBrochuresForm'))
const ManageMarketingEvents = lazy(() => import('../../components/marketingHub/manageMarketingEvents/ManageMarketingEvents'))
const MarketingEventsForm = lazy(() => import('../../components/marketingHub/manageMarketingEvents/MarketingEventsForm'))
const ManageRecommendedVideos = lazy(() => import('../../components/marketingHub/manageRecommendedVideos/ManageRecommendedVideos'))
const RecommendedVideosForm = lazy(() => import('../../components/marketingHub/manageRecommendedVideos/RecommendedVideosFrom'))
const ManageMarketingVideos = lazy(() => import('../../components/marketingHub/manageMarketingVideos/ManageMarketingVideos'))
const MarketingVideosForm = lazy(() => import('../../components/marketingHub/manageMarketingVideos/MarketingVideosForm'))
const ManageIndustryNews = lazy(() => import('../../components/marketingHub/manageindustrynews/ManageIndustryNews'))
const IndustryNewsForm = lazy(() => import('../../components/marketingHub/manageindustrynews/IndustryNewsForm'))
const ManageThoughtLeadership = lazy(() => import('../../components/marketingHub/managethoughtleadership/ManageThoughtLeadership'))
const ThoughtLeadershipForm = lazy(() => import('../../components/marketingHub/managethoughtleadership/ThoughtLeadershipForm'))

const ManageMarketingInsights = lazy(() => import('../../components/marketingHub/manageMarketingInsights/ManageInsights'))
const MarketingInsightsForm = lazy(() => import('../../components/marketingHub/manageMarketingInsights/MarketingInsightsForm'))
const ManagePodcasts = lazy(() => import('../../components/marketingHub/managemarketingpodcasts/ManagePodcasts'))
const PodcastsForm = lazy(() => import('../../components/marketingHub/managemarketingpodcasts/PodcastsForm'))
const ManageMarketingAwards = lazy(() => import('../../components/marketingHub/managemarketingawards/ManageMarketingAwards'))
const MarketingAwardsForm = lazy(() => import('../../components/marketingHub/managemarketingawards/MarketingAwardsForm'))
const ManageAuthors = lazy(() => import('../../components/marketingHub/manageSolutionAuthors/ManageAuthors'))
const AuthorsForm = lazy(() => import('../../components/marketingHub/manageSolutionAuthors/AuthorsForm'))
const ResourcePulseHub = lazy(() => import('../../components/resourcepulsehub/ResourcePulseHub'))
const ProfileSearch = lazy(() => import('../../components/resourcepulsehub/ProfileSearch'))
const ManageHomeGallery = lazy(() => import('../../components/manageHomeGallery/ManageHomeGallery'))
const HomeGalleryForm = lazy(() => import('../../components/manageHomeGallery/HomeGalleryForm'))
const ManageHubs = lazy(() => import('../../components/manageHubs/ManageHubs'))
const HubsForm = lazy(() => import('../../components/manageHubs/HubsForm'))
const PeopleHubHome = lazy(() => import('../../components/peoplehubhome/PeopleHubHome'))
const ManageEmployeeSpotlight = lazy(() => import('../../components/employeeSpotlight/ManageEmployeeSpotlight'))
const EmployeeSpotlightForm = lazy(() => import('../../components/employeeSpotlight/EmployeeSpotlightForm'))
const AnnouncementsForm = lazy(() => import('../../components/manageAnnouncements/AnnouncementsForm'))
const ManageAnnouncements = lazy(() => import('../../components/manageAnnouncements/ManageAnnouncements'))
const ManagePeopleHubGallery = lazy(() => import('../../components/managepeoplehubgallery/ManagePeopleHubGallery'))
const PeopleHubGalleryForm = lazy(() => import('../../components/managepeoplehubgallery/PeopleHubGalleryForm'))
const ActiveEmployeesFilterPage = lazy(() => import('../../components/resourcepulsehub/ActiveEmployeesFilterPage'));
const CertificationFilterPage = lazy(() => import('../../components/resourcepulsehub/CertificationFilterPage'));
const NewHirePage = lazy(() => import('../../components/resourcepulsehub/NewHirePage'));
const EmployeeProfile = lazy(() => import('../../components/resourcepulsehub/EmployeeProfile'));
const BenchResourceFilterPage = lazy(() => import('../../components/resourcepulsehub/BenchResourceFilterPage'));
const ManageAgilisiumCorner = lazy(() => import('../../components/manageagilisiumcorner/ManageAgilisiumCorner'));
const AgilisiumCornerForm = lazy(() => import('../../components/manageagilisiumcorner/AgilisiumCornerForm'));
const BusinessUnitFilterPage = lazy(() => import('../../components/resourcepulsehub/BusinessUnitFilterPage'));
const RevenueEngineFilterPage = lazy(() => import('../../components/resourcepulsehub/RevenueEngineFilterPage'));
const PrimaryDepartmentFilterPage = lazy(() => import('../../components/resourcepulsehub/PrimaryDepartmentFilterPage'));
const ResignedEmployeesFilterPage = lazy(() => import('../../components/resourcepulsehub/ResignedEmployeesFilterPage'));
const ExitEmployeesFilterPage = lazy(() => import('../../components/resourcepulsehub/ExitEmployeesFilterPage'));
const ContractsHubCustomerHome = lazy(() => import('../../components/contractsHub/CustomerTab.jsx'));
const ContractsHubVendorHome = lazy(() => import('../../components/contractsHub/VendorTab.jsx'));
const PracticeHub = lazy(() => import('../../components/practiceHub/PracticeHub'));
const ManagePracticeInsights = lazy(() => import('../../components/practiceHub/managePracticeInsights/ManagePracticeInsights'));
const PracticesForm = lazy(() => import('../../components/practiceHub/practices/PracticesForm.jsx'));
const ManagePracticeAnnouncements = lazy(() => import('../../components/practiceHub/managePracticeAnnouncements/ManagePracticeAnnouncements.jsx'));
const PracticeAnnouncementsForm = lazy(() => import('../../components/practiceHub/managePracticeAnnouncements/PracticeAnnouncementsForm.jsx'));
const ContractsHubHomePage = lazy(() => import('../../components/contractsHub/ContractsHubHomePage.jsx'));
const FlipHubHome = lazy(() => import('../../components/FlipHub/FlipHubHome.jsx'));
const ManageFlipHubEpisodes = lazy(() => import('../../components/FlipHub/ManageFlipHubEpisodes.jsx'));
const FlipHubEpisodesForm = lazy(() => import('../../components/FlipHub/FlipHubEpisodeForm.jsx'));
const PracticeDetails = lazy(() => import('../../components/practiceHub/practiceDetails/PracticeDetails'));
const AdminHub = lazy(() => import('../../components/adminHub/AdminHubHome.jsx'));
const ManageSeats = lazy(() => import('../../components/adminHub/ManageSeats.jsx'));
const ManageSeatsForm = lazy(() => import('../../components/adminHub/ManageSeatsForm.jsx'));
const TownSquare = lazy(() => import('../../components/townsquare/TownSquare.jsx'));
const ManageTownSquareEpisodes = lazy(() => import('../../components/townsquare/ManageTownSquareEpisodes.jsx'));
const TownSquareEpisodesForm = lazy(() => import('../../components/townsquare/TownSquareEpisodeForm.jsx'));
const TlfHomePage = lazy(() => import('../../components/FlipHub/TLF.jsx'));
const BrainGym = lazy(() => import('../../components/braingym/BrainGym.jsx'));
const ManageBrainGymEpisodes = lazy(() => import('../../components/braingym/ManageBrainGymEpisodes.jsx'));
const BrainGymEpisodesForm = lazy(() => import('../../components/braingym/BrainGymEpisodeForm.jsx'));
const KnowHowNow = lazy(() => import('../../components/knowhownow/KnowHowNow.jsx'));
const ManageKnowHowNowEpisodes = lazy(() => import('../../components/knowhownow/ManageKnowHowNowEpisodes.jsx'));
const KnowHowNowEpisodesForm = lazy(() => import('../../components/knowhownow/KnowHowNowEpisodeForm.jsx'));
const EmployeesByAccountFilterPage = lazy(() => import('../../components/resourcepulsehub/EmployeesByAccountFilterPage'));
const ImmigrationHub = lazy(() => import('../../components/immigrationHub/ImmigrationHub'));
const ImmigrationGuidelines = lazy(() => import('../../components/immigrationHub/ImmigrationGuidelines'));
const ManageMarketingHubUsers = lazy(() => import('../../components/marketingHub/managemarketinghubusers/ManageMarketingHubUsers'));
const FutureFlexResourceFilterPage = lazy(() => import('../../components/resourcepulsehub/FutureFlexResourceFilterPage'));
const ProPointHomePage = lazy(() => import('../../components/propoint/propoint.jsx'));
const ManageProPointEpisodes = lazy(() => import('../../components/propoint/ManageProPointEpisodes.jsx'));
const ProPointEpisodesForm = lazy(() => import('../../components/propoint/propointEpisodeForm.jsx'));
const KfmHomePage = lazy(() => import('../../components/kfm/Kfm.jsx'));
const ManageKfmEpisodes = lazy(() => import('../../components/kfm/ManageKfmEpisodes.jsx'));
const KfmEpisodesForm = lazy(() => import('../../components/kfm/KfmepisodeForm.jsx'));
const ManagePracticeMilestones = lazy(() => import('../../components/practiceHub/managePracticeMilestones/managePracticeMilestones.jsx'));
const PracticeMilestonesForm = lazy(() => import('../../components/practiceHub/managePracticeMilestones/practiceMilestonesForm.jsx'));
const ManagePracticeSkills = lazy(() => import('../../components/practiceHub/managePracticeSkills/managePracticeSkills.jsx'));
const PracticeSkillsForm = lazy(() => import('../../components/practiceHub/managePracticeSkills/practiceSkillsForm.jsx'));
const WSRPracticeFilterPage = lazy(() => import('../../components/resourcepulsehub/WSRPracticeFilterPage'));
const WSRAccountFilterPage = lazy(() => import('../../components/resourcepulsehub/WSRAccountFilterPage'));


class NavRoutes extends React.Component {
    render() {
        return (
            <Suspense fallback={<ContainerLoader />}>
                <Routes>
                    <>
                        <Route
                            path={RouteKeys.Home}
                            element={
                                <AuthenticateRoute>
                                    <Home />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={RouteKeys.Homeroute}
                            element={
                                <AuthenticateRoute>
                                    <Home />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={RouteKeys.AddUser}
                            element={
                                <AuthenticateRoute>
                                    <AddUser />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={RouteKeys.Auth}
                            element={
                                <RedirectIfAuthenticatedRoute>
                                    <AuthPage />
                                </RedirectIfAuthenticatedRoute>
                            }
                        />
                        <Route
                            path={RouteKeys.AzureLogin}
                            element={
                                <RedirectIfAuthenticatedRoute>
                                    <AzureLogin />
                                </RedirectIfAuthenticatedRoute>
                            }
                        />
                        <Route
                            path={RouteKeys.CreateUser}
                            element={
                                <AuthenticateRoute>
                                    <CreateUser />
                                </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={RouteKeys.EditUser}
                            element={
                                <AuthenticateRoute>
                                    <EditUser />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={RouteKeys.EmployeeGram}
                            element={
                                <AuthenticateRoute>
                                    <EmployeeComms />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={PeopleHubRouteKeys.FindYourAssociates}
                            element={
                                <AuthenticateRoute>
                                    <KnowYourAssociates />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={ResourcePulseHubRouteKeys.AssociateDetails}
                            element={
                                <AuthenticateRoute>
                                    <AssociateDetails />
                                </AuthenticateRoute>
                            }
                        />
                        <Route path={RouteKeys.wallOfFame} element={<AuthenticateRoute>
                            <WallOfFame />
                        </AuthenticateRoute>}>

                        </Route>

                        <Route path={PeopleHubRouteKeys.whatsnew} element={<AuthenticateRoute>
                            <WhatsNew />
                        </AuthenticateRoute>}>

                        </Route>

                        <Route
                            path={PeopleHubRouteKeys.PoliciesAndBenefits}
                            element={
                                <AuthenticateRoute>
                                    <Policies />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={PeopleHubRouteKeys.AddPolicyForm}
                            element={
                                <AuthenticateRoute>
                                    <AddPolicyForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={PeopleHubRouteKeys.ManagePolicy}
                            element={
                                <AuthenticateRoute>
                                    <ManagePolicy />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={PeopleHubRouteKeys.ClientSummary}
                            element={
                                <AuthenticateRoute>
                                    <ClientSummary />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={PeopleHubRouteKeys.WhatsNewForm}
                            element={
                                <AuthenticateRoute>
                                    <WhatsNewForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={ProcessHubRouteKeys.BusinessUnits}
                            element={
                                <AuthenticateRoute>
                                    <Contact />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={RouteKeys.LearningLounge}
                            element={
                                <AuthenticateRoute>
                                    <LearningLounge />
                                </AuthenticateRoute>
                            }
                        />

                        <Route path={RouteKeys.wallofFameForm} element={<AuthenticateRoute>
                            <WalloffameForm />
                        </AuthenticateRoute>}>

                        </Route>
                        <Route
                            path={RouteKeys.ManageInsights}
                            element={
                                <AuthenticateRoute>
                                    <ManageAgilisiumInsights />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={RouteKeys.InsightsForm}
                            element={
                                <AuthenticateRoute>
                                    <InsightsForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={RouteKeys.ManageItHub}
                            element={
                                <AuthenticateRoute>
                                    <ItHub />
                                </AuthenticateRoute>
                            }
                        />
                        <Route path={RouteKeys.ItHubForm} element={<AuthenticateRoute>
                            <ItHubForm />
                        </AuthenticateRoute>}>

                        </Route>
                        <Route
                            path={RouteKeys.ManageFlashNews}
                            element={
                                <AuthenticateRoute>
                                    <FlashNews />
                                </AuthenticateRoute>
                            }
                        />
                        <Route path={RouteKeys.FlashNewsForm} element={<AuthenticateRoute>
                            <FlashNewsForm />
                        </AuthenticateRoute>}>

                        </Route>
                        <Route
                            path={RouteKeys.PrivacyPolicy}
                            element={
                                <AuthenticateRoute>
                                    <PrivacyPolicy />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={RouteKeys.TermsAndConditions}
                            element={
                                <AuthenticateRoute>
                                    <TermsAndConditions />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={ProcessHubRouteKeys.OrganizationChart}
                            element={
                                <AuthenticateRoute>
                                    <OrganizationChart />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={TalentTransformationalHubRouteKeys.MangageLearningLounge}
                            element={
                                <AuthenticateRoute>
                                    <ManageLearningLounge />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={TalentTransformationalHubRouteKeys.LearningLoungeTable}
                            element={
                                <AuthenticateRoute>
                                    <LearningLoungeTable />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={TalentTransformationalHubRouteKeys.LearningLoungeForm}
                            element={
                                <AuthenticateRoute>
                                    <LearningLoungeForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={PeopleHubRouteKeys.ManageClientDetails}
                            element={
                                <AuthenticateRoute>
                                    <ClientDetails />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={PeopleHubRouteKeys.ClientDetailsForm}
                            element={
                                <AuthenticateRoute>
                                    <ClientDetailsForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={ProcessHubRouteKeys.ManageDepartments}
                            element={
                                <AuthenticateRoute>
                                    <ManageDepartments />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={ProcessHubRouteKeys.ManageDocuments}
                            element={
                                <AuthenticateRoute>
                                    <ManageDocuments />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={ProcessHubRouteKeys.DocumentsForm}
                            element={
                                <AuthenticateRoute>
                                    <DocumentsForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={ProcessHubRouteKeys.DepartmentsForm}
                            element={
                                <AuthenticateRoute>
                                    <DepartmentsForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={RouteKeys.Reports}
                            element={
                                <AuthenticateRoute>
                                    <SimpleLineChart />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={RouteKeys.Survey}
                            element={
                                <AuthenticateRoute>
                                    <Survey />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={RouteKeys.ManageSurvey}
                            element={
                                <AuthenticateRoute>
                                    <ManageSurvey />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={RouteKeys.SurveyMasterForm}
                            element={
                                <AuthenticateRoute>
                                    <SurveyMasterForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={RouteKeys.SurveyQuestionsForm}
                            element={
                                <AuthenticateRoute>
                                    <SurveyQuestionsForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={ProcessHubRouteKeys.ProcessHub}
                            element={
                                <AuthenticateRoute>
                                    <ProcessHub />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={TalentTransformationalHubRouteKeys.TalentTransformationalHub}
                            element={
                                <AuthenticateRoute>
                                    <LearningLounge />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={MarketingHubRouteKeys.MarketingHub}
                            element={
                                <AuthenticateRoute>
                                    <MarketingHub />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={MarketingHubRouteKeys.ManageMarketingBrochures}
                            element={
                                <AuthenticateRoute>
                                    <ManageMarketingBrochures />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={MarketingHubRouteKeys.MarketingBrochuresForm}
                            element={
                                <AuthenticateRoute>
                                    <MarketingBrochuresForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={MarketingHubRouteKeys.ManageMarketingEvents}
                            element={
                                <AuthenticateRoute>
                                    <ManageMarketingEvents />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={MarketingHubRouteKeys.MarketingEventsForm}
                            element={
                                <AuthenticateRoute>
                                    <MarketingEventsForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={MarketingHubRouteKeys.Solutions}
                            element={
                                <AuthenticateRoute>
                                    <Solutions />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={MarketingHubRouteKeys.ManageSolutions}
                            element={
                                <AuthenticateRoute>
                                    <ManageSolutions />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={MarketingHubRouteKeys.ManageIndustryNews}
                            element={
                                <AuthenticateRoute>
                                    <ManageIndustryNews />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={MarketingHubRouteKeys.ManageMarketingInsights}
                            element={
                                <AuthenticateRoute>
                                    <ManageMarketingInsights />
                                </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={MarketingHubRouteKeys.ManageMarketingInsights}
                            element={
                                <AuthenticateRoute>
                                    <ManageMarketingInsights />
                                </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={MarketingHubRouteKeys.MarketingInsightsForm}
                            element={
                                <AuthenticateRoute>
                                    <MarketingInsightsForm />
                                </AuthenticateRoute>
                            }
                        />


                        <Route
                            path={MarketingHubRouteKeys.SolutionsForm}
                            element={
                                <AuthenticateRoute>
                                    <SolutionsForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={MarketingHubRouteKeys.IndustryNewsForm}
                            element={
                                <AuthenticateRoute>
                                    <IndustryNewsForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={MarketingHubRouteKeys.ManageRecommendedVideos}
                            element={
                                <AuthenticateRoute>
                                    <ManageRecommendedVideos />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={RouteKeys.ManageThoughtLeadership}
                            element={
                                <AuthenticateRoute>
                                    <ManageThoughtLeadership />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={MarketingHubRouteKeys.RecommendedVideosForm}
                            element={
                                <AuthenticateRoute>
                                    <RecommendedVideosForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={RouteKeys.ThoughtLeadershipForm}
                            element={
                                <AuthenticateRoute>
                                    <ThoughtLeadershipForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={MarketingHubRouteKeys.ManageMarketingVideos}
                            element={
                                <AuthenticateRoute>
                                    <ManageMarketingVideos />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={MarketingHubRouteKeys.ManagePodcasts}
                            element={
                                <AuthenticateRoute>
                                    <ManagePodcasts />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={MarketingHubRouteKeys.MarketingVideosForm}
                            element={
                                <AuthenticateRoute>
                                    <MarketingVideosForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={MarketingHubRouteKeys.PodcastsForm}
                            element={
                                <AuthenticateRoute>
                                    <PodcastsForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={MarketingHubRouteKeys.ManageMarketingAwards}
                            element={
                                <AuthenticateRoute>
                                    <ManageMarketingAwards />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={MarketingHubRouteKeys.MarketingAwardsForm}
                            element={
                                <AuthenticateRoute>
                                    <MarketingAwardsForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={MarketingHubRouteKeys.ManageAuthors}
                            element={
                                <AuthenticateRoute>
                                    <ManageAuthors />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={MarketingHubRouteKeys.AuthorsForm}
                            element={
                                <AuthenticateRoute>
                                    <AuthorsForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={ResourcePulseHubRouteKeys.ResourcePulseHub}
                            element={
                                <AuthenticateRoute>
                                    <ResourcePulseHub />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={ResourcePulseHubRouteKeys.ProfileSearch}
                            element={
                                <AuthenticateRoute>
                                    <ProfileSearch />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={ResourcePulseHubRouteKeys.ManageAssociateProfiles}
                            element={
                                <AuthenticateRoute>
                                    <ComingSoon />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={ResourcePulseHubRouteKeys.ActiveEmployeesFilterPage}
                            element={
                                <AuthenticateRoute>
                                    <ActiveEmployeesFilterPage />
                                </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={ResourcePulseHubRouteKeys.NewHirePage}
                            element={
                                <AuthenticateRoute>
                                    <NewHirePage />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={ResourcePulseHubRouteKeys.CertificationFilterPage}
                            element={
                                <AuthenticateRoute>
                                    <CertificationFilterPage />
                                </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={ResourcePulseHubRouteKeys.BenchResourceFilterPage}
                            element={
                                <AuthenticateRoute>
                                    < BenchResourceFilterPage />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={ResourcePulseHubRouteKeys.FutureFlexResourceFilterPage}
                            element={
                                <AuthenticateRoute>
                                    <FutureFlexResourceFilterPage />
                                </AuthenticateRoute>
                            }
                        />


                        <Route
                            path={ResourcePulseHubRouteKeys.EmployeeProfile}
                            element={
                                <AuthenticateRoute>
                                    <EmployeeProfile />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={ResourcePulseHubRouteKeys.BusinessUnitFilterPage}
                            element={
                                <AuthenticateRoute>
                                    <BusinessUnitFilterPage />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={ResourcePulseHubRouteKeys.RevenueEngineFilterPage}
                            element={
                                <AuthenticateRoute>
                                    <RevenueEngineFilterPage />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={ResourcePulseHubRouteKeys.PrimaryDepartmentFilterPage}
                            element={
                                <AuthenticateRoute>
                                    <PrimaryDepartmentFilterPage />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={ResourcePulseHubRouteKeys.ResignedEmployeesFilterPage}
                            element={
                                <AuthenticateRoute>
                                    <ResignedEmployeesFilterPage />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={ResourcePulseHubRouteKeys.ExitEmployeesFilterPage}
                            element={
                                <AuthenticateRoute>
                                    <ExitEmployeesFilterPage />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={ResourcePulseHubRouteKeys.EmployeesByAccountFilterPage}
                            element={
                                <AuthenticateRoute>
                                    <EmployeesByAccountFilterPage />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={ResourcePulseHubRouteKeys.WSRPracticeFilterPage}
                            element={
                                <AuthenticateRoute>
                                    <WSRPracticeFilterPage />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={ResourcePulseHubRouteKeys.WSRAccountFilterPage}
                            element={
                                <AuthenticateRoute>
                                    <WSRAccountFilterPage />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={RouteKeys.ManageHubSpoc}
                            element={
                                <AuthenticateRoute>
                                    <ManageHubSpoc />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={PeopleHubRouteKeys.PeopleHub}
                            element={
                                <AuthenticateRoute>
                                    <PeopleHubHome />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={RouteKeys.HubSpocForm}
                            element={
                                <AuthenticateRoute>
                                    <HubSpocForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={RouteKeys.ManageHomeGallery}
                            element={
                                <AuthenticateRoute>
                                    <ManageHomeGallery />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={RouteKeys.HomeGalleryForm}
                            element={
                                <AuthenticateRoute>
                                    <HomeGalleryForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={RouteKeys.ManageHubs}
                            element={
                                <AuthenticateRoute>
                                    <ManageHubs />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={RouteKeys.HubsForm}
                            element={
                                <AuthenticateRoute>
                                    <HubsForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={PeopleHubRouteKeys.ManageEmployeeSpotlight}
                            element={
                                <AuthenticateRoute>
                                    <ManageEmployeeSpotlight />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={PeopleHubRouteKeys.EmployeeSpotlightForm}
                            element={
                                <AuthenticateRoute>
                                    <EmployeeSpotlightForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={PeopleHubRouteKeys.ManageAnnouncements}
                            element={
                                <AuthenticateRoute>
                                    <ManageAnnouncements />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={PeopleHubRouteKeys.AnnouncementsForm}
                            element={
                                <AuthenticateRoute>
                                    <AnnouncementsForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={PeopleHubRouteKeys.ManagePeopleHubGallery}
                            element={
                                <AuthenticateRoute>
                                    <ManagePeopleHubGallery />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={PeopleHubRouteKeys.PeopleHubGalleryForm}
                            element={
                                <AuthenticateRoute>
                                    <PeopleHubGalleryForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={RouteKeys.ManageAgilisiumCorner}
                            element={
                                <AuthenticateRoute>
                                    <ManageAgilisiumCorner />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={RouteKeys.AgilisiumCornerForm}
                            element={
                                <AuthenticateRoute>
                                    <AgilisiumCornerForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={ContractsHubRouteKeys.ContractsHubCustomer}
                            element={
                                <AuthenticateRoute>
                                    <ContractsHubCustomerHome />
                                </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={ContractsHubRouteKeys.ContractsHubVendor}
                            element={
                                <AuthenticateRoute>
                                    <ContractsHubVendorHome />
                                </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={PracticeHubRouteKeys.PracticeHub}
                            element={
                                <AuthenticateRoute>
                                    <PracticeHub />
                                </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={PracticeHubRouteKeys.PracticeDetails}
                            element={
                                <AuthenticateRoute>
                                    <PracticeDetails />
                                </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={PracticeHubRouteKeys.ManagePracticeInsights}
                            element={
                                <AuthenticateRoute>
                                    <ManagePracticeInsights />
                                </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={PracticeHubRouteKeys.PracticesForm}
                            element={
                                <AuthenticateRoute>
                                    <PracticesForm />
                                </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={PracticeHubRouteKeys.ManagePracticeAnnouncements}
                            element={
                                <AuthenticateRoute>
                                    <ManagePracticeAnnouncements />
                                </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={PracticeHubRouteKeys.PracticeAnnouncementsForm}
                            element={
                                <AuthenticateRoute>
                                    <PracticeAnnouncementsForm />
                                </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={PracticeHubRouteKeys.ManagePracticeMilestones}
                            element={
                                <AuthenticateRoute>
                                    <ManagePracticeMilestones />
                                </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={PracticeHubRouteKeys.PracticeMilestonesForm}
                            element={
                                <AuthenticateRoute>
                                    <PracticeMilestonesForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={PracticeHubRouteKeys.ManagePracticeSkills}
                            element={
                                <AuthenticateRoute>
                                    <ManagePracticeSkills />
                                </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={PracticeHubRouteKeys.PracticeSkillsForm}
                            element={
                                <AuthenticateRoute>
                                    <PracticeSkillsForm />
                                </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={ContractsHubRouteKeys.ContractsHubHomePage}
                            element={
                                <AuthenticateRoute>
                                    <ContractsHubHomePage />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={FlipHubRouteKeys.FlipHub}
                            element={
                                <AuthenticateRoute>
                                    <FlipHubHome />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={FlipHubRouteKeys.ManageFlipHubEpisodes}
                            element={
                                <AuthenticateRoute>
                                    <ManageFlipHubEpisodes />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={FlipHubRouteKeys.FlipHubEpisodesForm}
                            element={
                                <AuthenticateRoute>
                                    <FlipHubEpisodesForm />
                                </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={FlipHubRouteKeys.TownSquare}
                            element={<AuthenticateRoute>
                                <TownSquare />
                            </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={FlipHubRouteKeys.ManageTownSquareEpisodes}
                            element={<AuthenticateRoute>
                                <ManageTownSquareEpisodes />
                            </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={FlipHubRouteKeys.TownSquareEpisodesForm}
                            element={<AuthenticateRoute>
                                <TownSquareEpisodesForm />
                            </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={FlipHubRouteKeys.BrainGym}
                            element={<AuthenticateRoute>
                                <BrainGym />
                            </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={FlipHubRouteKeys.ManageBrainGymEpisodes}
                            element={<AuthenticateRoute>
                                <ManageBrainGymEpisodes />
                            </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={FlipHubRouteKeys.BrainGymEpisodesForm}
                            element={<AuthenticateRoute>
                                <BrainGymEpisodesForm />
                            </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={FlipHubRouteKeys.KnowHowNow}
                            element={<AuthenticateRoute>
                                <KnowHowNow />
                            </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={FlipHubRouteKeys.ManageKnowHowNowEpisodes}
                            element={<AuthenticateRoute>
                                <ManageKnowHowNowEpisodes />
                            </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={FlipHubRouteKeys.KnowHowNowEpisodesForm}
                            element={<AuthenticateRoute>
                                <KnowHowNowEpisodesForm />
                            </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={FlipHubRouteKeys.TLF}
                            element={<AuthenticateRoute>
                                <TlfHomePage />
                            </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={FlipHubRouteKeys.ProPoint}
                            element={<AuthenticateRoute>
                                <ProPointHomePage />
                            </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={FlipHubRouteKeys.ManageProPointEpisodes}
                            element={<AuthenticateRoute>
                                <ManageProPointEpisodes />
                            </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={FlipHubRouteKeys.Kfm}
                            element={<AuthenticateRoute>
                                <KfmHomePage />
                            </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={FlipHubRouteKeys.ManageKfmEpisodes}
                            element={<AuthenticateRoute>
                                <ManageKfmEpisodes />
                            </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={FlipHubRouteKeys.KfmEpisodesForm}
                            element={<AuthenticateRoute>
                                <KfmEpisodesForm />
                            </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={FlipHubRouteKeys.ProPointEpisodesForm}
                            element={<AuthenticateRoute>
                                <ProPointEpisodesForm />
                            </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={ImmigrationHubRouteKeys.ImmigrationHub}
                            element={
                                <AuthenticateRoute>
                                    <ImmigrationHub />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={ImmigrationHubRouteKeys.ImmigrationGuidelines}
                            element={
                                <AuthenticateRoute>
                                   <ImmigrationGuidelines />
                                </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={AdminHubRouteKeys.AdminHub}
                            element={
                                <AuthenticateRoute>
                                    <AdminHub />
                                </AuthenticateRoute>
                            }
                        />

                        <Route
                            path={AdminHubRouteKeys.ManageSeats}
                            element={
                                <AuthenticateRoute>
                                    <ManageSeats />
                                </AuthenticateRoute>
                            }
                        />

                         <Route
                            path={AdminHubRouteKeys.ManageSeatsForm}
                            element={
                                <AuthenticateRoute>
                                    <ManageSeatsForm />
                                </AuthenticateRoute>
                            }
                        />
                        <Route
                            path={MarketingHubRouteKeys.ManageMarketingHubUsers}
                            element={
                                <AuthenticateRoute>
                                   <ManageMarketingHubUsers />
                                </AuthenticateRoute>
                            }
                        />

                        <Route path={RouteKeys.NotFound} element={NotFound} />
                        <Route path="*" element={NotFound} />
                    </>
                </Routes>
            </Suspense>
        );
    }
}

export default NavRoutes;
